import React from "react";
import Dialog from "../index";
import { Button as ReactButton } from "react-bootstrap";
import styled, { css } from "styled-components";
import Text from "../../../../../../_components/Text";
import * as colors from "../../../../../../assets/_base/colors";
import {
  downaloadDANFE,
  downaloadXML,
  getNFeBase64,
} from "../../../../../../api/nfe";
import { deleteLocalStorageItem, donwloadBase64, getCookieByName } from "../../../../../../utils";

const ShadedButton = styled(ReactButton)`
    min-width: 100px;
    border-radius: 10px !important
    background: #2f4050
    border-bottom-color: #1ab394 !important
    border-bottom-width: 6px !important;
    background-color: #2f4050 !important

    :hover{
        background: #1ab394
    }
    :focus{}
    :disabled{
        opacity: .4;
        cursor: not-allowed;
    }
    ${(props) => {
    if (props.pdf) {
      return css`
            background-color: #fe0000 !important
            border-bottom-width: 7px !important
            border-bottom-color: #a20a09 !important
            `;
    }
    if (props.xml) {
      return css`
            background-color: #006000 !important
            border-bottom-width: 7px !important
            border-bottom-color: #003100 !important
            `;
    }
    if (props.wpp) {
      return css`
            background-color: #00eb00 !important
            border-bottom-width: 7px !important
            border-bottom-color: #028c02 !important
            `;
    }
  }}
`;

export default (props) => {
  const [downloading, setDownloading] = React.useState(false);
  function whatsAppShare() {
    setDownloading(true);
    getNFeBase64({ key: props.nfe.key, return_type: "link" })
      .then((data) => {
        //console.debug(data);
        let phone_number = props.nfe.identification.recipient_phone_number;
        let branchName = getCookieByName("branch_owner_name")
        phone_number = `55${phone_number}`.replace(/\D/g, "");
        const dataLink = "https://influen.cr/share-wpp-nfe";
        const message = `Olá. Boa notícia! A sua Nota Fiscal já se encontra disponível. ✅\n\nEssa é uma mensagem automática da Easygestor, sistema de gestão e documentos fiscais no Brasil\n\n📍Emitente: ${branchName}\n\nAbrir em pdf: ${data.pdf}\n\nAbrir em xml: ${data.xml}\n\nConheça mais sobre a Easygestor e emita notas grátis 🧾: ${dataLink}`
        const formatedMessage = encodeURIComponent(message);
        window.open(
          `https://api.whatsapp.com/send/?phone=${phone_number}?&text=${formatedMessage}`,
          "_blank"
        );
      })
      .finally(() => {
        setTimeout(() => setDownloading(false), 400);
      });
  }
  function downloadFile(type) {
    setDownloading(true);
    const download = type === "pdf" ? downaloadDANFE : downaloadXML;
    download(props.nfe.id)
      .then((resp) => {
        donwloadBase64(
          `${props.nfe.key}`,
          type,
          `application/${type}`,
          resp.data
        );
      })
      .finally(() => {
        setTimeout(() => setDownloading(false), 400);
      });
  }
  function onHide() {
    deleteLocalStorageItem("currentStep")
    deleteLocalStorageItem("nfe")
    location.reload()
  }
  function handleChange() {
    if (props.show === true) {
      downloadFile("pdf")
    }
  }
  React.useEffect(handleChange, [props.show]);
  return (
    <Dialog show={props.show} onHide={onHide}>
      <p
        className={`${downloading ? "d-block" : "d-none"
          } lead text-info text-center m-0 p-0 py-3`}
      >
        Baixando arquivo ...
      </p>
      <div className="" data-cy-test="#nfe-issuer-body-of-alert-nfe-authorized">
        <Text color="primary">
          Esta nota já encontre-se disponível para download ou compartilhamento.
        </Text>
        <div className="d-flex justify-content-between px-3 my-4">
          <div>
            <ShadedButton disabled={downloading} wpp onClick={whatsAppShare}>
              <i className="" />
              <i
                className={`${downloading
                    ? "fas fa-spin fa-spinner"
                    : "fab fa-2x fa-whatsapp"
                  } fa-2x`}
              />
            </ShadedButton>
            <Text color="primary">Whatsapp</Text>
          </div>
          <div>
            <ShadedButton
              disabled={downloading}
              pdf
              onClick={() => downloadFile("pdf")}
            >
              <i
                className={`fas ${downloading ? "fa-spin fa-spinner" : "fa-file-pdf"
                  } fa-2x`}
              />
            </ShadedButton>
            <Text color="primary">DANFE (PDF)</Text>
          </div>
          <div>
            <ShadedButton
              disabled={downloading}
              xml
              onClick={() => downloadFile("xml")}
            >
              <i
                className={`fas ${downloading ? "fa-spin fa-spinner" : "fa-file-code"
                  } fa-2x`}
              />
            </ShadedButton>
            <Text color="primary">XML</Text>
          </div>
        </div>
      </div>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/Dialog/NFeAuthorized/index.jsx